<header class="dashboard-layout__header header">
  <div class="header__actions">
    <button
      class="header__btn"
      (click)="checkForUpdates()"
      [title]="api.version.id"
    >
      <i class="bx bx-refresh" [class.bx-spin]="loading_update"></i>
      <span class="header__btn-label">{{
        loading_update ? "Mise à jour..." : api.version.id
      }}</span>
    </button>

    <div class="header__dropdown dropdown">
      <div
        class="header__status"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="header__status-label"
          >{{ api.les_utilisateurs.length }} utilisateurs en ligne <i
              class="bx bxs-circle me-2"
              [style.color]="api.les_utilisateurs.length < 0 ? '#ffab00' : '#71dd37'"
              style="font-size: 8px"
            ></i></span
        >
      </div>

      <ul class="dropdown-menu dropdown-menu-end shadow border-0">
        <li class="dropdown-header">Utilisateurs en ligne</li>
        <li *ngFor="let un_utilisateur of api.les_utilisateurs">
          <a class="dropdown-item d-flex align-items-center">
            <i
              class="bx bxs-circle me-2"
              [style.color]="un_utilisateur.moi ? '#ffab00' : '#71dd37'"
              style="font-size: 8px"
            ></i>
            <span [class.text-warning]="un_utilisateur.moi">{{
              un_utilisateur?.titre
            }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="header__user-section">
    <div class="header__dropdown dropdown">
      <div
        class="header__profile"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="header__profile-name">
          {{ api.token.token_decoded.taf_data.prenom }}
          {{ api.token.token_decoded.taf_data.nom }}
        </span>
        <div class="header__avatar">
          <img src="../assets/img/our/avatar.png" alt="Avatar" />
        </div>
      </div>

      <ul class="dropdown-menu dropdown-menu-end shadow border-0">
        <li>
          <a class="dropdown-item" [routerLink]="['/home/profil']">
            <i class="bx bx-user me-2"></i> Mon profil
          </a>
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li>
          <button class="dropdown-item text-danger" (click)="logout()">
            <i class="bx bx-power-off me-2"></i> Déconnexion
          </button>
        </li>
      </ul>
    </div>
  </div>
</header>
